// roster 명부 — 작전 구성 화면의 roster 탭
//
// **목록에는 닉네임과 marching 이 뜨고, 아군 줄에만 게임 ID 가 함께 붙는다**
// (2026-08-05 결정을 2026-08-16 에 사용자가 개정).
//
// 처음에는 게임 ID 를 목록 어디에도 올리지 않기로 했는데, 그 규칙이 **CT 가 등재된 ID 를
// 되읽을 길을 통째로 없앤다**는 것이 뒤늦게 드러났다. 이 제품의 방어선이 인증이 아니라
// 명단이라 「못 들어간다」를 푸는 사람이 CT 인데, 무엇이 올라 있는지 못 보면 남는 길이
// 「지우고 다시 올린다」뿐이고 그것은 대조가 아니라 덮어쓰기다.
//
// **넓어진 것은 CT 가 보는 자리 하나뿐이다.** 계약의 `Roster` 는 여전히
// `{id, side, nickname, marchingMs}` 이고 앞으로도 그렇다 — 그 응답과 `rosters.updated`
// 방송은 **연맹원에게도 간다.** 값은 CT 전용 문(`GET /api/ct/whitelist`)에서만 따로 온다.
// 브라우저 검증이 두 방향을 함께 잰다: 아군 줄에 **자기** ID 가 붙는가, 그리고 적군 목록과
// 연맹원 화면과 rally select 에 **한 곳도** 없는가. 뒤의 것이 이 개정의 불통 조건이다.
//
// ── 등록 폼은 신규 전용이다. 고치는 자리는 목록의 그 줄이다 ────────────────
//
// whitelist 는 한때 **같은 게임 ID 를 다시 등록하면 그 사람의 닉네임을 고치는 것으로** 봤다.
// 오타를 고칠 경로가 필요해서 열어 둔 문인데 대가가 있었다 — 게임 ID 를 한 자리 잘못 친
// CT 는 사람을 하나 더한다고 믿지만 실제로는 **멀쩡한 연맹원의 이름을 갈아치웠다.** 목록이
// 닉네임 순으로 다시 정렬되므로 줄 수가 그대로인 것조차 눈에 띄지 않고, 아군 명부는 이
// 제품의 방어선이라 사라진 이름은 rally 배정에서 다시 나타난다. (2026-08-11 사람 관점
// 채점이 재현해 보고했다.)
//
// 2026-08-12 에 그 겸직을 끊었다. **등록은 새 사람만 올린다** — 이미 있는 게임 ID 도, 이미
// 있는 이름도 서버가 409 로 거절한다. 이름을 고치는 자리는 목록의 그 줄이고, 게임 ID 를
// 잘못 친 줄은 지우고 다시 올린다. 무엇이 일어나는지가 **입력값이 아니라 누른 버튼**에
// 달리게 하는 것이 이 갈라놓기의 전부다.
//
// 그래서 이 화면은 CT 의 whitelist 를 미리 읽어 두지 않는다. 읽던 이유가 「이 등록이 이름을
// 바꾸는 등록인가」를 누르기 **전에** 알기 위해서였는데, 이제 그런 등록이 없다.
//
// ── 지우는 것은 되돌릴 수 없다. 그래서 무엇이 사라지는지 말한다 ────────────
//
// 확인을 서버가 아니라 화면이 지는 이유가 여기 있다. 서버는 같은 요청을 두 번 받지 않는다 —
// 되돌릴 수 없는 조작이라는 사실과 **무엇이 함께 사라지는지**를 사람에게 말하는 것이 화면의
// 일이고, 서버가 그것을 대신하면 그 문구를 어디에도 못 적는다.
//
// 적 줄의 누적 marching 은 인게임에서 한 번씩 눈으로 재어 모은 값이라 다시 못 모은다. 그래서
// 확인 문구가 그 값을 **글자로 읽어 준다** — 「정말 지울까요」는 무엇을 잃는지 말하지 않는다.
// 아군 줄은 값 대신 **그 사람 화면이 끊긴다**는 것을 말한다. 그쪽이 되돌릴 수 없는 조각이다.
//
// ── 시간 문법의 주인은 이 파일이 아니다 ────────────────────────────────────
//
// 사람이 치는 `4:00` 을 읽는 것은 `src/core/timing/format.ts` 의 `parseTimeInput` 이고,
// 무엇이 유효한 시간인가의 판단은 `src/core/time/brand.ts` 하나가 내린다. 이 화면이
// 자기 파서를 가지면 같은 `4:00` 이 어디서 읽혔느냐에 따라 다른 수가 되고, **그 차이는
// 화면에 보이지 않는다.**
//
// 표시도 같은 층을 쓴다. `formatDuration` 이 `4:00.0` 처럼 분 자리에 앞의 0 을 채우지
// 않는 제품 형식을 낸다 — `brand.ts` 의 `formatMmss` 는 저장·전송 경계의 정규형이라
// `04:00.0` 을 내놓고, 그것이 화면에 뜨면 형식이 두 벌인 것이다.
//
// ── 행군을 고치는 자리는 여기 하나다 ───────────────────────────────────────
//
// rally 편집기에도 열람 화면에도 이 문을 내지 않는다. 문이 여럿이면 dispatch 된 시퀀스가
// 구성 시점 delta 로 확정된다는 계약이 조용히 무너진다. 그래서 이 화면은 갱신을 계약의
// `POST /api/rosters/marching` 하나로만 보낸다.
//
// **진행 중 시퀀스를 다시 계산하지 않는다.** 값을 고친 뒤 이 화면이 하는 일은 자기
// 목록을 다시 읽는 것뿐이다.
//
// ── 그런데 「다시 계산하지 않는다」를 이 화면이 말하지 않고 있었다 ──────────
//
// 계약은 행군에 대해 두 문장을 갖고 있다. 진행 중 작전은 구성 시점 delta 로 확정돼
// **움직이지 않는다**, 그리고 바뀐 값은 **다음 구성과 다시 잡기가 쓴다.** 그 둘이
// attack 탭에는 두 문장으로 놓여 있는데 **명부에는 한 글자도 없었다** — 정작 행군을
// 고치는 손이 여기 있는데도 그렇다. 2026-08-15 대리 관측이 그 자리를 적었다.
//
// 그래서 이 화면이 작전에 대해 하는 말을 세우되 **상태에서 파생시킨다.** 저장해 두면
// 작전이 끝난 뒤에도 문장만 살아남아 화면이 없는 작전을 말하게 되는데, 이 저장소는 삭제
// 경고문에서 그 대가를 이미 한 번 치렀다(2026-08-13 사람 관점 채점). 파생값으로 두면 그
// 어긋남이 고쳐지는 것이 아니라 생길 수 없다.
//
// **말이 두 자리에 선다. 자리마다 다른 것을 답하기 때문이다.**
//
//   위쪽 띠   — 지금 작전이 있는가. 고치기 **전에** 읽는다
//   줄 안의 말 — 방금 고친 이 값이 그 작전에 갔는가. 고친 **직후에** 읽는다
//
// 줄 안에도 두는 이유는 이 파일이 이미 아는 것이다 — 연맹원이 20~50명이면 위쪽 띠는
// 화면 밖으로 나간다. 목록 아래 한 자리에 말을 모으지 않은 이유와 같은 이유다.
//
// 줄 안의 말은 **그 사람이 그 작전에 실제로 들어 있을 때만** 붙는다. 작전에 없는 사람의
// 줄에 「조립 중인 작전에 반영했습니다」가 뜨면 화면이 거짓을 말한다.
//
// 시퀀스는 **새 경로를 파지 않고** `use-sequence.ts` 를 읽는다. 두 벌이 되면 재접속
// 처리와 방송 해석이 서로 다르게 낡는다. 소켓은 늘지 않는다 — `subscribeServerEvents`
// 가 토큰 하나당 하나를 나눠 쓰고, 작전 구성 화면은 한 번에 한 탭만 그린다.
//
// ── 언어는 아직 기본값에 묶여 있다 ─────────────────────────────────────────
//
// 탭 슬롯의 `render` 가 인자를 받지 않아 상단 고정줄의 KO/EN 선택이 여기까지 닿지
// 않는다. 지금은 영어 문자열이 전부 비어 한국어로 되돌아오므로 **두 언어에서 화면이
// 글자 하나 다르지 않고**, 그래서 이 스텝은 슬롯 모양을 바꾸지 않았다. 세 탭이 함께
// 쓰는 타입이라 한 스텝이 혼자 고칠 자리가 아니다. 영어를 채우는 마감 스텝이 그때
// 슬롯에 언어를 실어야 한다.

import { useCallback, useEffect, useRef, useState } from 'react'

import type { Roster, Sequence, WhitelistEntry } from '../../../../contract/schema.ts'
import { duration, toMillis } from '../../../../core/time/brand.ts'
import { formatDuration, parseTimeInput } from '../../../../core/timing/format.ts'
import { roster as rosterStrings, type RosterStrings } from '../../../../i18n/index.ts'
import {
  call,
  CT_TOKEN_KEY,
  readToken,
  routes,
  subscribeServerEvents,
} from '../../../access/client.ts'
import { accept, issue, newReadOrder, supersede } from '../../../access/read-order.ts'
import { useLang } from '../../../shell/use-lang.ts'
import { NextStep } from '../attack/index.tsx'
import { useSequence } from '../attack/use-sequence.ts'
import { useComposeCue } from '../shell/cue.ts'
import { Icon, IconTile } from '../../../ui/icons.tsx'

/** 지금 고른 언어의 문자열 한 벌. **모듈에 굳히지 않는다** — 굳히면 언어를 바꿔도 안 따라온다. */
function useStrings(): RosterStrings {
  return rosterStrings(useLang().lang)
}

/** 문장 안의 `{이름}` 자리를 채운다. 번역이 붙을 때 어순이 달라져도 견디게 하는 최소한이다. */
function fill(template: string, values: Record<string, string>): string {
  return Object.entries(values).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, value),
    template,
  )
}

/**
 * 밀리초를 사람이 읽는 글자로. **격자를 벗어난 값에도 화면이 죽지 않는다.**
 *
 * `formatDuration` 은 0.1초 격자 밖의 값을 조용히 반올림하지 않고 예외를 던진다 —
 * 반올림하면 사람이 적은 값과 계산에 쓰인 값이 갈리기 때문이다. 저장 경계가 그런 값을
 * 막지만, 막기 전에 들어간 값이 남아 있으면 목록 전체가 렌더 중에 죽는다. 그때 명부를
 * 통째로 잃는 것보다 그 줄에 원시 값을 드러내는 편이 낫다.
 */
function showMarching(millis: number | null, t: RosterStrings): string {
  if (millis === null) return t.needsInput
  try {
    return formatDuration(duration(millis))
  } catch {
    return `${String(millis)}ms`
  }
}

function toInputText(millis: number | null): string {
  if (millis === null) return ''
  try {
    return formatDuration(duration(millis))
  } catch {
    return ''
  }
}

type Parsed = { ok: true; value: number | null } | { ok: false }

/** 빈 칸은 「아직 못 쟀다」이지 0 이 아니다. 둘이 같은 값이 되면 착탄 미상이 사라진다. */
function parseMarching(text: string): Parsed {
  const trimmed = text.trim()
  if (trimmed === '') return { ok: true, value: null }
  try {
    return { ok: true, value: toMillis(parseTimeInput(trimmed)) }
  } catch {
    return { ok: false }
  }
}

/** 한 줄에 붙는 말. 실패만 말하고 성공을 침묵하면 같은 값을 다시 저장했을 때 눌렀는지도 모른다. */
interface RowMessage {
  tone: 'ok' | 'bad'
  text: string
}

/**
 * 지우기 전에 하는 말. **무엇이 함께 사라지는지를 값으로 읽어 준다.**
 *
 * 네 갈래인 이유는 사라지는 것이 진영마다 다르고, 행군이 빈 줄에는 읽어 줄 값이 없기
 * 때문이다. 빈 줄에 같은 문장을 쓰면 「행군 입력필요 가 사라집니다」가 되어, 확인 문구가
 * 스스로 말이 안 되는 문장을 사람에게 내민다.
 */
/**
 * 이름 끝의 받침을 보고 조사를 고른다. **되돌릴 수 없는 조작 앞에서 읽히는 유일한
 * 문장이라 한국어가 깨져 있으면 그 문장의 무게가 함께 깎인다** — 「이영희은」·「카이이」.
 *
 * 한글 음절은 유니코드에서 `(코드 − AC00) % 28` 이 0 이면 받침이 없다. 한글로 끝나지
 * 않는 이름(라틴 문자·숫자)은 고를 근거가 없어 받침 없는 쪽을 쓴다 — 틀려도 문장의 뜻은
 * 상하지 않고, 실제 방의 아군은 전부 한글로 끝난다.
 */
function particle(name: string, withBatchim: string, without: string): string {
  const last = name.trimEnd().at(-1) ?? ''
  const code = last.codePointAt(0) ?? 0
  if (code < 0xac00 || code > 0xd7a3) return without
  return (code - 0xac00) % 28 === 0 ? without : withBatchim
}

function removeConfirmText(row: Roster, t: RosterStrings): string {
  const value = showMarching(row.marchingMs, t)
  const blank = row.marchingMs === null
  const name = row.nickname
  if (row.side === 'ally') {
    // **「지금 열려 있는 화면도 끊깁니다」라고 단정하지 않는다.** 아무도 접속해 있지 않은
    // 줄에서도 같은 문장이 뜨면 화면이 사실이 아닌 것을 말한다. 이 화면은 그 사람이 지금
    // 붙어 있는지를 모르므로, 아는 것만 말하는 조건문으로 적는다.
    const topic = particle(name, '은', '는')
    return blank
      ? fill(t.removeConfirmAllyBlank, { name, topic })
      : fill(t.removeConfirmAlly, { name, topic, value })
  }
  const subject = particle(name, '이', '가')
  return blank
    ? fill(t.removeConfirmEnemyBlank, { name, subject })
    : fill(t.removeConfirmEnemy, { name, value })
}

/**
 * 명부 위쪽 띠 — **지금 작전이 있는가, 그리고 여기서 고친 값이 언제 그것에 닿는가.**
 *
 * 계약의 두 갈래를 그대로 옮긴 것이라 갈래도 둘이다. `dispatched` 는 얼어붙은 값을 쓰므로
 * 지금 고쳐도 안 움직이고, 그 앞의 두 상태(`draft`·`confirmed`)는 명부의 지금 값을 그때
 * 그때 읽으므로 곧바로 반영된다. 그 갈림은 규율이 아니라 저장 구조에 있다 — dispatch 가
 * 각 rally 행에 행군을 얼린다.
 *
 * **작전이 없으면 아무 말도 하지 않는다.** 줄이 하나도 없는 `draft` 는 아직 작전이 아니고,
 * 그때 「고친 값이 반영됩니다」를 띄우면 화면이 없는 것을 가리킨다.
 */
function operationSay(sequence: Sequence | null, t: RosterStrings): string {
  if (sequence === null) return ''
  if (sequence.state === 'dispatched') return t.operationDispatched
  if (sequence.rallies.length === 0) return ''
  return t.operationAssembling
}

/**
 * 행군을 저장한 줄이 덧붙이는 말 — **그 사람이 그 작전에 들어 있을 때만 붙는다.**
 *
 * 들어 있지 않은 사람에게 작전 이야기를 하면 화면이 사실이 아닌 것을 말한다. 적군 줄에
 * 이 말이 한 번도 안 붙는 것도 같은 이유다 — 공격 시퀀스의 rally 는 전부 아군의 것이다.
 *
 * **비우는 것은 고치는 것과 결과가 다르다.** 조립 중인 시퀀스는 rally 마다 명부의 지금
 * 행군을 실어 내는데, 그 값이 없는 줄은 **아예 빠진 채로 나온다**(`src/server/sequence.ts`
 * 가 `marchingMs === null` 인 줄을 건너뛴다). 그래서 비운 뒤에 「반영했습니다」라고만 하면
 * 화면이 실제로 일어난 일보다 약하게 말하고, 곧이어 위쪽 띠가 스스로 바뀌면 **한 화면이
 * 자기와 다른 말을 하는** 상태가 된다. 무엇이 빠지는지를 그 자리에서 말한다 — 지우기 전에
 * 사라질 값을 읽어 주는 것과 같은 규칙이다.
 *
 * 내보낸 작전에는 이 갈림이 없다. 행군이 그 행에 얼어붙어 있어 비우든 고치든 한 자리도
 * 안 움직인다.
 *
 * **말할 수 없는 자리가 하나 남고, 그것을 아는 채로 남긴다.** 행군을 다시 넣어 그 줄이
 * 작전으로 돌아오는 순간에는 아무 말도 못 한다 — 누르기 직전의 시퀀스에 그 사람이 없고,
 * 그 사람에게 rally 행이 기다리고 있다는 사실은 **응답에 실려 오지 않기 때문이다.**
 * 모르면서 아는 척하는 것보다 침묵이 낫고, 그 자리는 위쪽 띠가 이미 「고친 값이 곧바로
 * 반영됩니다」로 덮는다. 말하려면 계약이 그 사실을 실어 와야 하고 계약은 남의 소유다.
 */
function savedSay(
  sequence: Sequence | null,
  rosterId: string,
  cleared: boolean,
  t: RosterStrings,
): string {
  if (sequence === null) return ''
  if (!sequence.rallies.some((line) => line.rosterId === rosterId)) return ''
  if (sequence.state === 'dispatched') return t.savedWhileDispatched
  return cleared ? t.clearedWhileAssembling : t.savedWhileAssembling
}

export function RosterView(): React.ReactElement {
  const t = useStrings()
  const [ctToken] = useState<string | null>(() => readToken(CT_TOKEN_KEY))
  // 작전에 대해 할 말의 근거. **읽기만 한다** — 이 화면은 시퀀스를 한 글자도 고치지 않고,
  // 고치는 문이 여럿이면 「구성 시점 delta 로 확정된다」가 조용히 무너진다.
  //
  // **값을 치른 것을 정직하게 적어 둔다.** 이 훅은 자기 몫으로 명부도 한 번 읽으므로
  // (좌열 폼의 미리보기가 고른 사람의 지금 행군을 쓴다) roster 탭이 뜰 때마다 명부
  // 요청이 둘이 된다. roster 는 작전 구성 화면의 첫 탭이라 CT 가 들어올 때마다 그렇다.
  // 아래 목록은 적군도 필요해서 `store.allies` 로 대신할 수 없다. CT 한 명의 화면에서
  // 요청 하나가 느는 것이라 값을 매기지 않았지만, 이 훅을 다른 탭이 또 물고 들어가면
  // 그때는 세어 볼 자리다.
  const { sequence } = useSequence(ctToken)
  const [rosters, setRosters] = useState<Roster[]>([])
  const [drafts, setDrafts] = useState<Record<string, string>>({})
  const [messages, setMessages] = useState<Record<string, RowMessage>>({})
  const [loaded, setLoaded] = useState(false)

  // **한 번에 한 줄만 편집한다.** 여러 줄을 동시에 열면 CT 가 어느 줄을 고치는 중인지
  // 화면에서 잃고, 이름은 유일해야 하므로 두 줄이 같은 이름으로 동시에 저장되는 순간
  // 뒤에 누른 쪽만 409 를 받아 앞의 성공이 조용히 묻힌다.
  const [editing, setEditing] = useState<string | null>(null)
  const [nameDrafts, setNameDrafts] = useState<Record<string, string>>({})
  // 한 번 더 누르기를 기다리는 줄. 되돌릴 수 없는 조작 앞에서 화면이 지는 몫이다.
  const [pendingRemove, setPendingRemove] = useState<string | null>(null)
  // 지운 줄은 사라지므로 그 줄 안에 말을 남길 수 없다. 진영별로 목록 아래에 남긴다.
  const [removed, setRemoved] = useState<Record<string, string>>({})
  // 줄마다 **직전에 보여 주던** 행군 글자. 방송이 왔을 때 「사람이 이 칸을 만졌는가」를
  // 가르는 유일한 근거다. 상태로 두지 않는 이유는 이것이 그리는 값이 아니라 판정의
  // 기준점이라, 바뀌었다고 화면을 다시 그릴 이유가 없기 때문이다.
  const shownRef = useRef<Record<string, string>>({})
  // 이름 → 게임 ID. **아군만이고 CT 전용 문에서 온다.** 이름을 열쇠로 쓰는 이유는 명부
  // 응답의 `Roster.id` 가 whitelist 응답에는 없기 때문이고, 이름은 진영 안에서 유일하다.
  const [gameIds, setGameIds] = useState<Record<string, string>>({})

  /**
   * 목록을 갈아 끼울 때 줄마다의 입력 초안도 함께 맞춘다.
   *
   * **지웠다는 말도 여기서 거둔다.** 그 문장은 목록 밖에 사는데 목록 끝에 줄 하나처럼
   * 앉아 있어, 남겨 두면 명부의 마지막 행으로 오독될 자리에 있다. 다음 조작이 목록을
   * 다시 받는 순간이 그 말이 낡기 시작하는 순간이므로 거기서 거둔다. 지운 직후에는
   * 이 함수가 먼저 돌고 그 뒤에 말이 붙으므로 방금 지운 것은 지워지지 않는다.
   */
  const adopt = useCallback((next: Roster[]): void => {
    setRosters(next)
    const shown = Object.fromEntries(next.map((row) => [row.id, toInputText(row.marchingMs)]))
    setDrafts(shown)
    shownRef.current = shown
    setRemoved({})
  }, [])

  /**
   * 남의 창이 명부를 고쳐 방송이 왔을 때 갈아 끼운다.
   *
   * **`adopt` 와 갈라 둔 이유가 하나이고 그것이 전부다 — 누구의 조작인가.** 위쪽은 이 CT
   * 자신이 방금 누른 결과라, 모든 칸이 방금 앉은 값을 그대로 보여 주는 것이 맞다. 여기는
   * **남이 누른 결과**이고, 그때 이 화면에서 사람이 치고 있던 글자는 그 남의 것이 아니다.
   * 통째로 갈아 끼우면 다른 창의 조작이 이 CT 가 치던 글자를 지운다 — 등록 폼이 왕복 뒤에
   * 칸을 비우던 것과 같은 종류의 어긋남이고, 그때 세운 규칙을 여기서도 쓴다.
   *
   * 「사람이 만졌는가」의 판정은 **직전에 보여 주던 값과 아직 같은가**로 한다. 새 값과
   * 견주면 안 된다 — 남이 그 줄을 고쳐 값이 달라진 경우가 정확히 「사람이 만졌다」로
   * 오독되어, 손도 안 댄 칸에 낡은 값이 그대로 남는다.
   *
   * **지웠다는 말은 여기서 거두지 않는다.** 그 문장은 이 CT 가 방금 한 일의 기록이고,
   * 남의 창이 무엇을 하든 그 기록이 거짓이 되지는 않는다.
   */
  const absorb = useCallback((next: Roster[]): void => {
    // **기준점을 여기서 붙잡는다. 아래 갱신 함수 안에서 읽으면 안 된다.**
    //
    // 그 함수는 지금이 아니라 React 가 다시 그릴 때 돈다. 그 사이에 `shownRef` 를 새 값으로
    // 덮어 두면 「직전에 보여 주던 값」이 「지금 값」이 되어 **손도 안 댄 칸이 전부 「사람이
    // 만졌다」로 읽힌다.** 실제로 그렇게 짰다가 브라우저 검사에 걸렸고, 걸린 이유는 규칙의
    // 양쪽(치던 칸은 남는다 · 안 만진 칸은 따라간다)을 같은 회차에서 함께 쟀기 때문이다.
    const wasShown = shownRef.current
    const shown = Object.fromEntries(next.map((row) => [row.id, toInputText(row.marchingMs)]))
    shownRef.current = shown
    setRosters(next)
    setDrafts((previous) => {
      const kept: Record<string, string> = {}
      for (const row of next) {
        const held = previous[row.id]
        kept[row.id] = held === undefined || held === wasShown[row.id] ? (shown[row.id] ?? '') : held
      }
      return kept
    })
  }, [])

  /**
   * 그 줄이 하던 말을 거둔다.
   *
   * 거절 문구는 **그때 그 값에 대한 판정**이라, 값이 바뀌거나 편집을 버리면 더 이상 참이
   * 아니다. 이름이 [RVN]이영희인 줄 밑에 「이미 있는 이름입니다 — [KGS]철수형」이 붉게
   * 남아 있으면 명부를 훑는 CT 는 이영희의 줄에 지금 문제가 있다고 읽고, 넣을 칸도 없는데
   * 「다른 이름을 넣어 주세요」라는 지시까지 읽는다. 삭제 경고문을 무장 상태에 묶은 것과
   * 같은 규칙이고, 그 규칙이 닿는 자리가 셋이라 셋 다 묶는다.
   * (2026-08-13 사람 관점 2회차가 남은 한 곳을 잡았다.)
   */
  const clearRowSaid = useCallback((id: string): void => {
    setMessages((previous) => {
      if (previous[id] === undefined) return previous
      const { [id]: _dropped, ...rest } = previous
      return rest
    })
  }, [])

  /**
   * 아군의 게임 ID 를 CT 전용 문에서 따로 읽는다. **명부 응답으로 합치지 않는다.**
   *
   * 합치면 그 값이 `rosters.updated` 방송을 타고 연맹원 소켓까지 간다 — 열람 화면과 수비
   * 화면이 같은 명부 문을 읽기 때문이다. 문을 둘로 두는 대가는 왕복 하나이고, 그 왕복은
   * **CT 화면에서만** 일어난다.
   *
   * 실패하면 앞의 짝을 그대로 둔다. 비우면 이름 옆의 ID 가 깜빡였다 사라지는데, 그것은
   * 「이 사람은 게임 ID 가 없다」로 읽힐 수 있는 모양이라 아무 말도 안 하는 편보다 나쁘다.
   */
  const readGameIds = useCallback(async (): Promise<void> => {
    const result = await call<{ entries: WhitelistEntry[] }>(routes.ctWhitelist, {
      token: ctToken,
    })
    if (!result.ok) return
    setGameIds(Object.fromEntries(result.data.entries.map((row) => [row.nickname, row.gameId])))
  }, [ctToken])

  // **늦게 온 옛 명부 응답이 새 값을 덮지 않게 한다** (2026-09-28). 읽기의 옛 응답이 그 뒤의
  // `rosters.updated` 방송보다 늦게 도착할 수 있어서, 방송이 오면 그때까지 보낸 읽기를 옛것으로
  // 친다. 규칙과 까닭은 `src/web/access/read-order.ts` 가 진다.
  const rosterOrder = useRef(newReadOrder())

  const reload = useCallback(async (): Promise<void> => {
    const ticket = issue(rosterOrder.current)
    const [result] = await Promise.all([
      call<{ rosters: Roster[] }>(routes.rosters, { token: ctToken }),
      readGameIds(),
    ])
    if (result.ok && accept(rosterOrder.current, ticket)) adopt(result.data.rosters)
  }, [adopt, ctToken, readGameIds])

  useEffect(() => {
    void (async () => {
      await reload()
      setLoaded(true)
    })()
  }, [reload])

  /**
   * 명부 방송을 받는다. **2026-08-16 T1 개정이 계약의 `rosters.updated` 에 발신부를
   * 세우면서 이 화면이 첫 소비자가 됐다.**
   *
   * 그전까지 이 화면은 **자기가 누른 것만** 알았다. CT 창이 둘이면 한쪽에서 사람을 올리거나
   * 지워도 다른 쪽 명부는 낡은 채로 남고, 그 상태에서 이미 있는 사람을 다시 올리려다 409 를
   * 받으면 CT 는 화면이 맞는지 자기가 틀렸는지를 화면에 물어야 한다.
   *
   * **소켓을 새로 열지 않는다.** `subscribeServerEvents` 가 토큰 하나당 소켓 하나를 여러
   * 구독자에게 나눠 준다. 이 화면은 작전 띠 때문에 시퀀스 구독도 하나 갖고 있는데, 둘은
   * 같은 소켓의 두 청취자다.
   *
   * **다시 붙을 때 통째로 다시 읽는다.** 끊겨 있던 동안의 방송을 놓치면 화면은 낡은 목록을
   * 지금 값이라 믿고 조용히 앉아 있는다 — 이 저장소가 세 화면에서 각각 한 번씩 메운 구멍이다.
   */
  useEffect(() => {
    if (ctToken === null || ctToken === '') return
    return subscribeServerEvents(ctToken, {
      onEvent: (message) => {
        if (message.kind !== 'rosters.updated' || message['rosters'] === undefined) return
        supersede(rosterOrder.current)
        absorb(message['rosters'] as Roster[])
        // 게임 ID 짝도 함께 낡는다. 남의 창이 사람을 올리거나 이름을 고치면 이름이 열쇠인
        // 이 표가 어긋나므로, 방송이 온 김에 다시 읽는다. **방송에 그 값이 실려 있지 않은
        // 것은 의도다** — 그 방송은 연맹원 소켓에도 간다.
        void readGameIds()
      },
      onStatus: (status) => {
        if (status.connected) void reload()
      },
    })
  }, [absorb, ctToken, reload])

  const saveMarching = useCallback(
    async (row: Roster): Promise<void> => {
      const parsed = parseMarching(drafts[row.id] ?? '')
      if (!parsed.ok) {
        setMessages((previous) => ({ ...previous, [row.id]: { tone: 'bad', text: t.badTime } }))
        return
      }
      const result = await call<{ rosters: Roster[] }>(routes.rosterMarching, {
        body: { side: row.side, rosterId: row.id, marchingMs: parsed.value },
        token: ctToken,
      })
      if (!result.ok) {
        setMessages((previous) => ({
          ...previous,
          [row.id]: { tone: 'bad', text: result.message },
        }))
        return
      }
      adopt(result.data.rosters)
      // **작전에 갔는지를 저장한 그 자리에서 말한다.** 위쪽 띠가 같은 사실을 말하지만
      // 연맹원이 20~50명이면 그 띠는 화면 밖에 있다. 이 줄의 다른 말들을 목록 아래로
      // 모으지 않은 이유와 같은 이유다.
      //
      // 덧붙는 말은 **누른 순간의 상태**를 읽는다. 이 문장은 지금 상태의 서술이 아니라
      // 방금 일어난 일의 기록이라 뒤에 작전이 접혀도 거짓이 되지 않는다.
      const base =
        parsed.value === null
          ? t.marchingCleared
          : fill(t.marchingSaved, { value: showMarching(parsed.value, t) })
      const alsoSaid = savedSay(sequence, row.id, parsed.value === null, t)
      setMessages((previous) => ({
        ...previous,
        [row.id]: { tone: 'ok', text: alsoSaid === '' ? base : `${base} ${alsoSaid}` },
      }))
    },
    [adopt, ctToken, drafts, sequence, t],
  )

  const beginRename = useCallback(
    (row: Roster): void => {
      setEditing(row.id)
      setNameDrafts((previous) => ({ ...previous, [row.id]: row.nickname }))
      setPendingRemove(null)
      clearRowSaid(row.id)
    },
    [clearRowSaid],
  )

  /** 편집을 버리면 그 편집이 받은 거절도 함께 버린다. 줄은 원래 이름 그대로 남는다. */
  const cancelRename = useCallback(
    (row: Roster): void => {
      setEditing(null)
      clearRowSaid(row.id)
    },
    [clearRowSaid],
  )

  const cancelRemove = useCallback((): void => {
    setPendingRemove(null)
  }, [])

  const saveNickname = useCallback(
    async (row: Roster): Promise<void> => {
      const next = (nameDrafts[row.id] ?? '').trim()
      if (next === '') {
        setMessages((previous) => ({
          ...previous,
          [row.id]: { tone: 'bad', text: t.needNickname },
        }))
        return
      }
      const result = await call<{ rosters: Roster[] }>(routes.rosterNickname, {
        body: { side: row.side, rosterId: row.id, nickname: next },
        token: ctToken,
      })
      if (!result.ok) {
        // 겹치는 이름은 서버가 409 와 함께 그 이름을 되읽어 준다. 그 문장을 그대로 쓴다 —
        // 화면이 자기 말로 다시 적으면 서버가 막은 이유와 화면이 말하는 이유가 갈린다.
        setMessages((previous) => ({
          ...previous,
          [row.id]: { tone: 'bad', text: result.message },
        }))
        return
      }
      adopt(result.data.rosters)
      setEditing(null)
      setMessages((previous) => ({
        ...previous,
        [row.id]: { tone: 'ok', text: fill(t.renamed, { old: row.nickname, new: next }) },
      }))
    },
    [adopt, ctToken, nameDrafts, t],
  )

  const removeRow = useCallback(
    async (row: Roster): Promise<void> => {
      // 첫 누름은 지우지 않는다. **무엇이 사라지는지 말하고** 한 번 더 누르게 한다.
      //
      // **경고 문장을 여기서 저장하지 않는다.** 저장해 두면 무장이 풀린 뒤에도 문장만
      // 살아남아, 취소를 누른 CT 가 물러난 뒤에도 「한 번 더 누르면 지웁니다」가 적힌
      // 화면을 본다. 다른 줄을 무장하면 그런 문장이 둘 동시에 뜨고 무장된 줄은 하나도
      // 없는 상태가 된다 — 어느 줄이 위험한지 화면에 물어야 하는 상태다. 문장을 무장
      // 상태에서 **파생시키면** 그 어긋남이 고쳐지는 것이 아니라 생길 수 없게 된다.
      // (2026-08-13 사람 관점 채점이 재현해 보고했다.)
      if (pendingRemove !== row.id) {
        setPendingRemove(row.id)
        return
      }
      const result = await call<{ rosters: Roster[] }>(routes.rosterRemove, {
        body: { side: row.side, rosterId: row.id },
        token: ctToken,
      })
      if (!result.ok) {
        // **거절되면 무장을 푼다.** 무장한 줄은 거절 문장 대신 「한 번 더 누르면 지웁니다」를
        // 그려서, 풀지 않으면 서버가 왜 거절했는지가 가려진다. rally 를 맡은 아군의 거절
        // (2026-09-30 사용자 결정)이 푸는 길까지 말하는 문장이라 특히 보여야 한다.
        setPendingRemove(null)
        setMessages((previous) => ({
          ...previous,
          [row.id]: { tone: 'bad', text: result.message },
        }))
        return
      }
      adopt(result.data.rosters)
      setPendingRemove(null)
      setRemoved((previous) => ({
        ...previous,
        [row.side]: fill(t.removed, { name: row.nickname }),
      }))
    },
    [adopt, ctToken, pendingRemove, t],
  )

  const allies = rosters.filter((row) => row.side === 'ally')
  const enemies = rosters.filter((row) => row.side === 'enemy')
  const operating = operationSay(sequence, t)

  const listProps = {
    loaded,
    drafts,
    setDrafts,
    messages,
    saveMarching,
    editing,
    nameDrafts,
    setNameDrafts,
    clearRowSaid,
    beginRename,
    cancelRename,
    saveNickname,
    pendingRemove,
    cancelRemove,
    removeRow,
    removed,
    gameIds,
  }

  // 「다음:」 줄의 갈래를 한 자리에서 고른다. 줄의 글자와 탭 바의 강조가 같은 판단에서 나와야
  // 둘이 어긋나지 않는다.
  const opsStarted = sequence !== null && (sequence.state === 'dispatched' || sequence.rallies.length > 0)
  const next = allies.length === 0 ? 'seedAlly' : opsStarted ? 'opsInAttack' : 'goAttack'
  useComposeCue(loaded && next === 'goAttack' ? 'attack' : null)

  return (
    <section data-testid="roster-view" className="py-group" aria-label={t.title}>
      <p className="text-xs text-ink-mute">{t.displayRule}</p>
      <p className="mt-line text-xs text-ink-mute">{t.marchingOnlyHere}</p>

      {/* **다음 할 일 하나** (T2 개정 둘째, 2026-10-01 사용자). CT 가 들어오면 이 탭이 먼저
          서는데, ATTACK 과 DEFENSE 탭에는 있는 이 줄이 여기만 없었다. 빈 명부에서는 등록 폼
          둘이 같은 무게로 서서 무엇부터 올리는지 화면이 하나로 말하지 않았다(대리 관측). 읽기
          전에는 그리지 않는다. 빈 목록과 아직 안 온 목록을 섞으면 틀린 안내가 한 번 지나간다. */}
      {loaded && (
        <NextStep
          text={next === 'seedAlly' ? t.nextSeedAlly : next === 'opsInAttack' ? t.nextOpsInAttack : t.nextGoAttack}
        />
      )}

      {/* **작전이 없으면 이 줄 자체가 없다.** 자리만 잡아 두고 비워 두면 「작전 없음」을
          말하는 것이 되는데, 그 판정의 근거 케이스는 상단 고정줄의 것이라 이 화면이
          대신 답할 자리가 아니다. */}
      {operating !== '' && (
        <p
          data-testid="roster-operation"
          role="status"
          className="note note-accent mt-group text-sm"
        >
          {operating}
        </p>
      )}

      {/* 두 열은 뷰포트가 아니라 **열 하나가 받을 폭**으로 정한다(2026-08-25 사용자). 768px
          기준으로 열면 한 열이 약 348px 이라 버튼이 아랫줄로 내려가는 구간이 생겼다. 열
          최소폭 440px 은 편집 중 행(입력칸, 행군, 저장, 취소)과 읽는 행(닉네임, 게임 ID
          꼬리표, 행군, 이름 수정, 삭제)이 한 줄에 서는 값이고, `min(440px, 100%)` 이라
          폰 폭에서는 한 열이 화면을 넘지 않는다. */}
      <div className="mt-block grid gap-6 grid-cols-[repeat(auto-fit,minmax(min(440px,100%),1fr))]">
        <AllySide rosters={allies} ctToken={ctToken} reload={reload} list={listProps} />
        <EnemySide
          rosters={enemies}
          ctToken={ctToken}
          adopt={adopt}
          list={listProps}
          quiet={allies.length > 0}
        />
      </div>
    </section>
  )
}

interface ListProps {
  loaded: boolean
  drafts: Record<string, string>
  setDrafts: React.Dispatch<React.SetStateAction<Record<string, string>>>
  messages: Record<string, RowMessage>
  saveMarching: (row: Roster) => Promise<void>
  editing: string | null
  nameDrafts: Record<string, string>
  setNameDrafts: React.Dispatch<React.SetStateAction<Record<string, string>>>
  clearRowSaid: (id: string) => void
  beginRename: (row: Roster) => void
  cancelRename: (row: Roster) => void
  saveNickname: (row: Roster) => Promise<void>
  pendingRemove: string | null
  cancelRemove: () => void
  removeRow: (row: Roster) => Promise<void>
  removed: Record<string, string>
  /** 이름 → 게임 ID. **아군 줄에서만 읽는다** — 적에게는 게임 ID 자체가 없다. */
  gameIds: Record<string, string>
}

/**
 * 그 이름의 게임 ID. **아군 목록에만 붙고, 값은 CT 전용 문에서만 온다.**
 *
 * 2026-08-16 에 사용자가 2026-08-05 결정을 개정했다. 그 전에는 게임 ID 를 목록 어디에도
 * 올리지 않았는데, 그 규칙이 **CT 가 등재된 ID 를 되읽을 길을 통째로 없앤다**는 것이 뒤늦게
 * 드러났다. 이 제품의 방어선이 인증이 아니라 명단이라 「못 들어간다」를 푸는 사람이 CT 인데,
 * 무엇이 올라 있는지 못 보면 남는 길이 「지우고 다시 올린다」뿐이고 그것은 대조가 아니라
 * 덮어쓰기다.
 *
 * **명부 응답에서 가져오지 않는다.** 계약의 `Roster` 에는 게임 ID 칸이 없고 앞으로도 없다 —
 * 그 응답과 `rosters.updated` 방송은 **연맹원에게도 간다.** 열람 화면과 수비 화면이 같은
 * 문을 읽는다. 칸을 여는 순간 이 개정이 CT 자리 하나를 넓히는 것이 아니라 게임 ID 를 방
 * 전체에 뿌리는 것이 된다. 그래서 CT 전용 문(`GET /api/ct/whitelist`)에서 따로 읽어 **이름을
 * 열쇠로 맞춘다** — 이름은 진영 안에서 유일하고 그 유일성은 유니크 인덱스가 진다.
 *
 * 짝을 못 찾으면 아무것도 그리지 않는다. 방금 올린 사람이 명부 응답에는 있고 whitelist
 * 응답에는 아직 없는 순간이 있는데, 그때 `(모름)` 같은 자리표시를 그리면 화면이 없는 사실을
 * 말한다.
 */
function GameIdTag(props: { gameId: string | undefined }): React.ReactElement | null {
  if (props.gameId === undefined) return null
  return (
    <span data-testid="roster-row-game-id" className="font-mono text-xs text-ink-mute">
      ({props.gameId})
    </span>
  )
}

/**
 * 아군 — **whitelist 명단 그 자체다.**
 *
 * 등록이 `POST /api/ct/whitelist` 로 가는 것이 요점이다. 사람을 올리는 문이 둘이면 게임
 * ID 와 닉네임의 짝이 두 곳에 생기고, 어긋난 순간 입장 매칭과 rally 배정이 서로 다른
 * 사람을 가리킨다.
 */
function AllySide(props: {
  rosters: Roster[]
  ctToken: string | null
  reload: () => Promise<void>
  list: ListProps
}): React.ReactElement {
  const t = useStrings()
  const [gameId, setGameId] = useState('')
  const [nickname, setNickname] = useState('')
  const [marching, setMarching] = useState('')
  const [error, setError] = useState('')
  const [notice, setNotice] = useState('')

  /**
   * 칸의 값이 바뀌면 그 값에 대해 하던 말을 거둔다.
   *
   * 「이미 있는 이름입니다」를 띄운 채 이름을 고쳐도 붉은 줄이 남아 있으면, 값을 고친
   * 사람에게 화면이 계속 틀렸다고 말하는 상태가 된다. 삭제 경고문이 무장을 안 따라가던
   * 것과 같은 종류의 어긋남이다. (2026-08-13 사람 관점 채점 지적.)
   *
   * **성공 문구도 함께 거둔다. 의도한 것이다.** 「올렸습니다 — 김철수」는 방금 보낸 값에
   * 대한 말이라, 다음 사람을 올리려고 첫 글자를 치는 순간부터 지금 칸의 값과 무관해진다.
   * 성공의 증거는 목록에 새로 생긴 줄이 계속 들고 있으므로 문장이 사라져도 잃는 것이 없다.
   *
   * **다만 응답이 늦게 오면 그 문구가 다시 뜨고, 그것도 의도다.** 왕복 중에 다음 이름을
   * 치기 시작한 CT 는 칸이 안 비워지는 것 말고는 앞의 등록이 닿았는지 알 길이 없다. 이
   * 문구는 **사람의 이름을 부르므로** 지금 칸에 든 글자에 대한 말로 읽히지 않는다.
   */
  const clearSaid = useCallback((): void => {
    setError('')
    setNotice('')
  }, [])

  const add = useCallback(async (): Promise<void> => {
    const id = gameId.trim()
    const name = nickname.trim()
    if (id === '') {
      setError(t.needGameId)
      return
    }
    if (name === '') {
      setError(t.needNickname)
      return
    }
    const parsed = parseMarching(marching)
    if (!parsed.ok) {
      setError(t.badTime)
      return
    }

    // **이미 있는 사람인지 화면이 미리 판단하지 않는다.** 서버가 게임 ID 로도 이름으로도
    // 409 와 함께 이유를 되읽어 주고, 그 판단의 근거인 유일 인덱스도 서버에 있다. 화면이
    // 자기 사본으로 먼저 재면 그 사본이 낡은 순간 두 판단이 갈리고, 갈린 쪽이 이기는지는
    // 화면에 보이지 않는다.
    const result = await call<{ entries: WhitelistEntry[] }>(routes.ctWhitelistAdd, {
      body: { gameId: id, nickname: name, marchingMs: parsed.value },
      token: props.ctToken,
    })
    if (!result.ok) {
      setNotice('')
      setError(result.message)
      return
    }
    // 명부는 whitelist 응답이 아니라 명부 라우트에서 다시 읽는다. 그쪽이 아군과 적군을
    // 한 벌로 내고, 무엇보다 **게임 ID 가 실리지 않는 응답**이다.
    await props.reload()

    // **사람이 친 글자를 지우지 않는다.** 비움이 왕복 **뒤에** 오는데 이 폼은 왕복을 둘
    // 돈다(등록 · 명부 되읽기). 그 사이에 CT 가 다음 사람의 이름을 치기 시작하면 뒤늦게
    // 도착한 앞 응답이 방금 친 글자를 함께 지우고, 화면에는 「닉네임을 넣어 주세요」만
    // 떠서 CT 는 자기가 안 친 줄 안다. 실전에서 연달아 올리는 상황이 정확히 그 모양이다.
    // (2026-08-15 에 적군 폼에서 검사기가 먼저 넘어져 드러났다.)
    //
    // 그래서 **보낸 그 글자가 아직 그대로일 때만** 비운다 — 수비 등록 폼이 먼저 쓰던
    // 문법이고 여기서 그것에 맞춘다. 칸마다 따로 보는 이유는 CT 가 한 칸만 고칠 수 있기
    // 때문이다. 비교는 다듬기 전의 원 글자로 한다 — 칸에 실제로 들어 있는 것이 그것이다.
    setNotice(fill(t.allyAdded, { new: name }))
    setGameId((current) => (current === gameId ? '' : current))
    setNickname((current) => (current === nickname ? '' : current))
    setMarching((current) => (current === marching ? '' : current))
    setError('')
  }, [gameId, marching, nickname, props, t])

  return (
    <section aria-label={t.allyTitle} data-testid="roster-ally" className="card min-w-0">
      <div className="panel-head cat-neutral">
        <IconTile name="users" tone="neutral" />
        <h2 className="section-title">{t.allyTitle}</h2>
      </div>
      <p className="mt-line text-xs text-ink-mute">{t.allyWhy}</p>

      <div className="mt-group flex flex-wrap gap-2" data-testid="roster-ally-form">
        <Field
          testId="ally-game-id"
          label={t.allyGameId}
          hint={t.allyGameIdHint}
          value={gameId}
          onChange={(value) => {
            setGameId(value)
            clearSaid()
          }}
          mono
          numeric
        />
        <Field
          testId="ally-nickname"
          label={t.allyNickname}
          value={nickname}
          onChange={(value) => {
            setNickname(value)
            clearSaid()
          }}
        />
        <Field
          testId="ally-marching"
          label={t.allyMarching}
          value={marching}
          onChange={(value) => {
            setMarching(value)
            clearSaid()
          }}
          placeholder={t.marchingPlaceholder}
          mono
        />
        {/* 아군이 있으면 테두리 버튼이다. 그때 「다음:」은 ATTACK 을 가리키는데 등록이 채운 버튼이면 가장 센
            버튼이 다른 곳을 가리킨다(2026-10-07 대리 관측). 테두리여도 굵은 글씨면 여전히 가장 세게 읽혀(둘째 판)
            보통 굵기의 회색으로 둔다. 빈 명부에서는 「다음:」이 아군부터라고 하므로 채운다. */}
        <FormAction
          testId="ally-add"
          label={t.allyAdd}
          tone={props.rosters.length === 0 ? 'btn-primary' : 'btn-secondary'}
          outline={props.rosters.length > 0}
          quiet={props.rosters.length > 0}
          onClick={() => void add()}
        />
      </div>
      <p className="mt-line text-xs text-ink-mute">{t.allyMarchingNote}</p>
      <p className="mt-line text-xs text-ink-mute">{t.allyNewOnly}</p>
      {/* 손으로 옮겨 치는 아홉 자리 숫자라 오타는 드문 실수가 아닌데, 이름과 행군은 그
          줄에서 고쳐지고 열쇠가 되는 값 하나만 못 고친다. 길이 있는데 화면이 말하지
          않으면 없는 것과 같다. (2026-08-13 사람 관점 채점 지적.) */}
      <p className="mt-line text-xs text-ink-mute">{t.allyGameIdTypo}</p>

      <Says testId="roster-ally-notice" tone="ok" text={notice} />
      <Says testId="roster-ally-error" tone="bad" text={error} />

      <RosterList side="ally" rosters={props.rosters} empty={t.allyEmpty} {...props.list} />
    </section>
  )
}

/** 적군 — **이름만으로 등록된다.** marching 은 공수가 교대될 때 한 번씩 모은다. */
function EnemySide(props: {
  rosters: Roster[]
  ctToken: string | null
  adopt: (next: Roster[]) => void
  list: ListProps
  /**
   * 등록 버튼을 보통 굵기의 회색으로 그린다. 아군이 있으면 「다음:」이 ATTACK 을 가리키는데, 주황 테두리에 굵은
   * 글씨면 이 버튼이 가장 센 것으로 읽혔다(2026-10-07 대리 관측 셋째 판).
   */
  quiet: boolean
}): React.ReactElement {
  const t = useStrings()
  const [nickname, setNickname] = useState('')
  const [marching, setMarching] = useState('')
  const [error, setError] = useState('')
  const [notice, setNotice] = useState('')

  /** 아군 폼과 같은 이유다 — 칸의 값이 바뀌면 그 값에 대해 하던 말을 거둔다. */
  const clearSaid = useCallback((): void => {
    setError('')
    setNotice('')
  }, [])

  const add = useCallback(async (): Promise<void> => {
    const name = nickname.trim()
    if (name === '') {
      setError(t.needNickname)
      return
    }
    const parsed = parseMarching(marching)
    if (!parsed.ok) {
      setError(t.badTime)
      return
    }
    const before = props.rosters.length
    const result = await call<{ rosters: Roster[] }>(routes.enemyRosterAdd, {
      body: { nickname: name, marchingMs: parsed.value },
      token: props.ctToken,
    })
    if (!result.ok) {
      setError(result.message)
      return
    }
    props.adopt(result.data.rosters)
    // 줄 수가 안 늘었으면 이미 있던 적이다. 서버가 조용히 넘어가는 것이 맞지만, 화면이
    // 함께 조용하면 CT 는 자기가 넣은 행군 값이 들어간 줄 안다.
    const grew = result.data.rosters.filter((row) => row.side === 'enemy').length > before
    // 아군 폼과 같은 규율이다 — **보낸 그 글자가 아직 그대로일 때만** 비운다. 적을 연달아
    // 올리는 것이 이 폼의 평상시 쓰임이라 여기가 그 함정에 가장 가깝다.
    setNotice(fill(grew ? t.enemyAdded : t.enemyExisting, { new: name }))
    setNickname((current) => (current === nickname ? '' : current))
    setMarching((current) => (current === marching ? '' : current))
    setError('')
  }, [marching, nickname, props, t])

  return (
    <section aria-label={t.enemyTitle} data-testid="roster-enemy" className="card min-w-0">
      <div className="panel-head cat-neutral">
        <IconTile name="flag" tone="neutral" />
        <h2 className="section-title">{t.enemyTitle}</h2>
      </div>
      <p className="mt-line text-xs text-ink-mute">{t.enemyWhy}</p>

      <div className="mt-group flex flex-wrap gap-2" data-testid="roster-enemy-form">
        <Field
          testId="enemy-nickname"
          label={t.enemyNickname}
          value={nickname}
          onChange={(value) => {
            setNickname(value)
            clearSaid()
          }}
        />
        <Field
          testId="enemy-marching"
          label={t.enemyMarching}
          value={marching}
          onChange={(value) => {
            setMarching(value)
            clearSaid()
          }}
          placeholder={t.marchingPlaceholder}
          mono
        />
        <FormAction
          testId="enemy-add"
          label={t.enemyAdd}
          tone="btn-secondary"
          outline
          quiet={props.quiet}
          onClick={() => void add()}
        />
      </div>
      <p className="mt-line text-xs text-ink-mute">{t.enemyDuplicateNote}</p>

      <Says testId="roster-enemy-notice" tone="ok" text={notice} />
      <Says testId="roster-enemy-error" tone="bad" text={error} />

      <RosterList side="enemy" rosters={props.rosters} empty={t.enemyEmpty} {...props.list} />
    </section>
  )
}

/** 화면이 하는 말 한 줄. 실패는 `alert` 로, 성공은 조용한 상태 갱신으로 낭독기에 간다. */
function Says(props: {
  testId: string
  tone: 'ok' | 'bad'
  text: string
}): React.ReactElement | null {
  if (props.text === '') return null
  return (
    <p
      data-testid={props.testId}
      role={props.tone === 'bad' ? 'alert' : 'status'}
      className={`mt-group text-sm ${props.tone === 'bad' ? 'text-red-300' : 'text-cyan'}`}
    >
      {props.text}
    </p>
  )
}

/**
 * 폼 줄 끝의 실행 버튼. **입력칸과 같은 뼈대로 세운다.** 라벨 줄 하나와 컨트롤 하나다.
 *
 * 그냥 `self-end` 로 붙이면 안 되는 이유가 flex 의 정의에 있다. **줄의 높이를 정하는 것은
 * 그 줄에서 가장 큰 항목**인데, 이 폼에서 가장 큰 것은 입력칸 아래에 형식 힌트를 하나 더
 * 단 칸이다. 그래서 버튼이 입력칸이 아니라 그 힌트의 바닥에 가서 붙었다. 폰 폭 390 에서
 * 38px 어긋났다 (2026-08-28 사용자 지적).
 *
 * **고정 오차가 아니라는 것이 요점이다.** 힌트가 좁은 폭에서 두 줄로 접히면 어긋남이 더
 * 벌어진다. 그래서 여백을 손으로 밀어 맞추면 한 폭에서만 맞고 다른 폭에서 다시 어긋난다.
 * 라벨 자리를 비워 두면 버튼의 위가 입력칸의 위와 같아지고, 힌트는 그 아래로 흐른다.
 *
 * 투명 테두리는 장식이 아니다. 입력칸이 1px 테두리를 지고 있어서, 없으면 버튼이 위아래로
 * 2px 작다.
 */
function FormAction(props: {
  testId: string
  label: string
  tone: string
  /**
   * 테두리만 있는 버튼으로 그린다. **한 화면에 채운 버튼이 둘이면 다음 할 일이 둘로 보인다.**
   * 빈 명부의 「다음:」 줄은 아군부터라고 말하는데, 적군 「등록」이 진입 화면의 주 버튼과 같은
   * 주황으로 채워져 그쪽이 더 세게 보였다(2026-10-01 대리 관측). 색은 진영을 가르는 데 남긴다.
   */
  outline?: boolean
  /**
   * 보통 굵기의 회색 글자로 그린다(`btn-quiet`). 다음 할 일이 다른 곳을 가리킬 때 이 버튼이 가장 세게 읽히지 않게 한다. 테두리여도
   * 굵은 글씨면 여전히 가장 센 버튼으로 읽혔다(2026-10-07 대리 관측 둘째 판과 셋째 판, 잔량 계획서의 「T2 개정 셋째: 배포 전 보수 회차」 절).
   */
  quiet?: boolean
  onClick: () => void
}): React.ReactElement {
  return (
    <div className="flex flex-col gap-1 self-start text-xs">
      {/* 라벨 자리를 지키는 빈 줄. 낱말을 넣지 않는 이유는 폭까지 밀어 버리기 때문이다. */}
      <span aria-hidden="true" className="invisible select-none">
        &nbsp;
      </span>
      <button
        type="button"
        data-testid={props.testId}
        className={`btn ${props.tone} ${props.outline === true ? 'btn-outline' : ''} ${props.quiet === true ? 'btn-quiet' : ''}`}
        onClick={props.onClick}
      >
        <Icon name="plus" />
        {props.label}
      </button>
    </div>
  )
}

function Field(props: {
  testId: string
  label: string
  value: string
  onChange: (value: string) => void
  hint?: string
  placeholder?: string
  mono?: boolean
  numeric?: boolean
}): React.ReactElement {
  return (
    <label className="flex min-w-0 flex-1 flex-col gap-1 text-xs">
      <span className="font-medium text-ink-dim">{props.label}</span>
      <input
        data-testid={props.testId}
        className={`field px-2.5 text-sm ${
          props.mono === true ? 'font-mono' : ''
        }`}
        value={props.value}
        placeholder={props.placeholder}
        inputMode={props.numeric === true ? 'numeric' : undefined}
        autoComplete="off"
        onChange={(event) => {
          props.onChange(event.target.value)
        }}
      />
      {/* 형식을 미리 말한다. 실패한 뒤에 배우게 하면 그 한 번이 전투 직전이다. */}
      {props.hint !== undefined && <span className="text-ink-mute">{props.hint}</span>}
    </label>
  )
}

/**
 * 목록 — **닉네임과 marching 두 칸이다.**
 *
 * 줄마다 입력칸이 붙어 있는 이유는 갱신 자리가 여기 하나뿐이기 때문이다. 별도 편집
 * 화면으로 빼면 값을 고치는 데 화면을 떠나게 되고, marching 은 전투 중에 고치는 값이다.
 *
 * **줄이 하는 말은 그 줄 안에 둔다.** 목록 아래 한 자리에 모으면 연맹원이 20~50명일 때
 * 문구가 화면 밖으로 나가고, 아군과 적군에서 동시에 실패하면 같은 문장이 둘 떠서 어느
 * 쪽 것인지 구별할 단서가 없어진다. (2026-08-11 사람 관점 채점 지적.)
 */
function RosterList(
  props: ListProps & { side: 'ally' | 'enemy'; rosters: Roster[]; empty: string },
): React.ReactElement {
  const t = useStrings()
  // 지웠다는 말은 목록 밖에 산다. **지운 줄은 사라지므로 그 줄 안에 남길 수 없고**,
  // 마지막 한 줄을 지우면 목록 자체가 빈 문장으로 바뀌기 때문에 아래 빈 갈래에도 붙인다.
  const removedSay = (
    <Says testId={`roster-removed-${props.side}`} tone="ok" text={props.removed[props.side] ?? ''} />
  )

  // **아직 안 읽었으면 목록 표식을 달지 않는다.**
  //
  // 값이 오기 전에도 `roster-list-{side}` 를 달아 두면 그 표식은 「화면이 있다」만 말하고
  // 「값이 있다」는 말하지 않는다. 그것을 완료 신호로 쓴 검사는 아직 안 온 목록을 **빈
  // 목록으로** 읽고, 「이미 있으면 올리지 않는다」가 「없으니 올린다」로 뒤집혀 409 를
  // 부른다. 그 409 는 폼에 붉은 줄을 남긴 채 다음 시나리오로 흘러간다. 이 저장소가 같은
  // 함정에 여섯 번 걸렸고 그때마다 부르는 쪽에서 우회했는데, 표식을 가르면 우회할 일이
  // 없어진다. (2026-08-14 로딩 껍데기 · 2026-08-16 수비 손잡이.)
  //
  // 조용히 아무것도 안 그리지 않는 이유는 이 저장소의 다른 자리와 같다 — 빈 화면은
  // 미구현인지 고장인지 말하지 않는다.
  if (!props.loaded) {
    return (
      <p data-testid={`roster-reading-${props.side}`} className="mt-group text-sm text-ink-mute">
        {t.reading}
      </p>
    )
  }

  if (props.rosters.length === 0) {
    return (
      <>
        <p data-testid={`roster-list-${props.side}`} className="mt-group text-sm text-ink-mute">
          {props.empty}
        </p>
        {removedSay}
      </>
    )
  }

  return (
    <>
      <ul
        data-testid={`roster-list-${props.side}`}
        className="mt-group divide-y divide-line-hair border-t border-line-hair"
      >
        {props.rosters.map((row) => {
          const said = props.messages[row.id]
          const editing = props.editing === row.id
          const arming = props.pendingRemove === row.id
          return (
            <li
              key={row.id}
              data-testid="roster-row"
              data-side={row.side}
              data-roster-id={row.id}
              className="py-line text-sm"
            >
              <div className="flex flex-wrap items-center gap-2">
                {editing ? (
                  <>
                    {/* **읽는 줄이 통째로 폼이 된다.** 이름칸만 슬쩍 입력칸으로 바꾸면
                        지금 무엇을 고치는 중인지가 화면에서 흐려지고, 옆의 행군칸과 섞여
                        어느 「저장」이 무엇을 저장하는지 구별되지 않는다. */}
                    <input
                      data-testid="roster-row-nickname-input"
                      aria-label={`${row.nickname} ${t.renameLabel}`}
                      className="field min-w-24 flex-1 px-2.5 text-sm"
                      value={props.nameDrafts[row.id] ?? ''}
                      autoComplete="off"
                      onChange={(event) => {
                        const next = event.target.value
                        props.setNameDrafts((previous) => ({ ...previous, [row.id]: next }))
                        // 값이 바뀌면 그 값에 대한 거절은 더 이상 참이 아니다.
                        props.clearRowSaid(row.id)
                      }}
                    />
                    <button
                      type="button"
                      data-testid="roster-row-nickname-save"
                      className="btn btn-secondary"
                      onClick={() => void props.saveNickname(row)}
                    >
                      {t.save}
                    </button>
                    <button
                      type="button"
                      data-testid="roster-row-nickname-cancel"
                      className="btn btn-ghost"
                      onClick={() => {
                        props.cancelRename(row)
                      }}
                    >
                      {t.cancel}
                    </button>
                  </>
                ) : (
                  <>
                    {/* **이름과 게임 ID 를 한 span 에 담지 않는다.** 담으면 이 표식의
                        글자가 「이름」이 아니라 「이름과 ID」가 되어, 정확 일치로 줄을 집는
                        검사와 낭독기가 함께 뜻을 잃는다. 화면에는 나란히 붙어 보인다. */}
                    {/* **좁은 폭에서 게임 ID 가 이름을 밀어내지 않게 감싼다.** 감싸지
                        않으면 ID 는 제 너비를 온전히 받고 이름만 줄어든다 — 390픽셀에서
                        이름 칸이 필요한 42픽셀 중 24픽셀만 받아 첫 글자와 말줄임표만
                        남는 것을 대리 관측이 쟀다. 이 화면의 목적은 「누구의 행군이
                        얼마인가」이고 그 「누구」는 닉네임이다. 자리가 모자라면 **ID 가
                        아래 줄로 내려가고 이름이 온전히 남는다.** */}
                    <span className="flex min-w-24 flex-1 flex-wrap items-baseline gap-x-1">
                      <span data-testid="roster-row-nickname" className="truncate font-medium">
                        {row.nickname}
                      </span>
                      {props.side === 'ally' && <GameIdTag gameId={props.gameIds[row.nickname]} />}
                    </span>
                    <span
                      data-testid="roster-row-marching"
                      className={
                        row.marchingMs === null
                          ? 'chip chip-accent'
                          : 'font-mono font-medium tabular-nums'
                      }
                    >
                      {showMarching(row.marchingMs, t)}
                    </span>
                    <input
                      data-testid="roster-row-marching-input"
                      aria-label={`${row.nickname} ${t.columnMarching}`}
                      className="field w-24 px-2 font-mono text-sm"
                      placeholder={t.marchingPlaceholder}
                      value={props.drafts[row.id] ?? ''}
                      autoComplete="off"
                      onChange={(event) => {
                        const next = event.target.value
                        props.setDrafts((previous) => ({ ...previous, [row.id]: next }))
                        props.clearRowSaid(row.id)
                      }}
                    />
                    <button
                      type="button"
                      data-testid="roster-row-marching-save"
                      className="btn btn-secondary"
                      onClick={() => void props.saveMarching(row)}
                    >
                      {t.save}
                    </button>
                    {/* 버튼이 줄마다 같은 글자로 여럿 뜬다. 낭독기에는 그 줄이 누구의
                        줄인지가 안 실리므로 이름을 aria-label 로 붙여 가른다. */}
                    <button
                      type="button"
                      data-testid="roster-row-rename"
                      aria-label={`${row.nickname} ${t.rename}`}
                      className="btn btn-ghost"
                      onClick={() => {
                        props.beginRename(row)
                      }}
                    >
                      {t.rename}
                    </button>
                    <button
                      type="button"
                      data-testid="roster-row-remove"
                      aria-label={`${row.nickname} ${t.remove}`}
                      // 한 번 더 누르면 지워지는 상태를 **버튼이 스스로 드러낸다.** 문구만
                      // 바뀌면 위쪽 문장을 안 읽은 사람에게는 방금 전과 같은 버튼이다.
                      className={
                        arming
                          ? 'btn btn-danger-armed'
                          : 'btn btn-ghost text-red-300'
                      }
                      onClick={() => void props.removeRow(row)}
                    >
                      {t.remove}
                    </button>
                    {arming && (
                      <button
                        type="button"
                        data-testid="roster-row-remove-cancel"
                        className="btn btn-ghost"
                        onClick={props.cancelRemove}
                      >
                        {t.cancel}
                      </button>
                    )}
                  </>
                )}
              </div>
              {/* **무장한 줄의 경고는 상태에서 파생된다.** 무장이 풀리는 순간 —
                  취소를 눌렀든 다른 줄을 무장했든 — 이 문장도 함께 사라진다. */}
              {arming && (
                <p
                  data-testid="roster-row-remove-confirm"
                  role="alert"
                  className="mt-tight text-xs text-red-300"
                >
                  {removeConfirmText(row, t)}
                </p>
              )}
              {said !== undefined && !arming && (
                <p
                  data-testid="roster-row-message"
                  role={said.tone === 'bad' ? 'alert' : 'status'}
                  className={`mt-tight text-xs ${
                    said.tone === 'bad' ? 'text-red-300' : 'text-cyan'
                  }`}
                >
                  {said.text}
                </p>
              )}
            </li>
          )
        })}
      </ul>
      {removedSay}
      <p className="mt-line text-xs text-ink-mute">{t.marchingHelp}</p>
    </>
  )
}
